






























import { Vue, Component } from "vue-property-decorator";

@Component
export default class PasswordConfirmationSuccess extends Vue {}
